export const BLUE_SKY_EQUITY = 'blueSkyEquity'
export const BLUE_SKY_FIXED_INCOME = 'blueSkyFixedIncome'
export const OTC_ANALYTICS = 'otcAnalytics'
export const SMALL_CAP_LISTED = 'smallCapListed'
export const FIXED_INCOME_211 = 'fixedIncome211'
